export default function WordLimit(props) {
  console.log(props.wordLim);
  return (
    <div className="popupBg">
      <div className="popupDiv">
        <h3 className="popupHead">
          Hi, set a word limit you want to hit everyday!
        </h3>
        <div className="wordLimInputDiv">
          <input
            type="number"
            placeholder="100"
            id="wlInput"
            className="wordLimInput"
            onChange={props.handleChange}
            value={props.wordLim}
          />
          <label className="words" htmlFor="wlInput">
            Words
          </label>
        </div>
        <button className="btn" onClick={props.handleClick}>
          I will do it!
        </button>
      </div>
    </div>
  );
}
